import {
  ADD_NEW_CULPRIT,
  ADD_NEW_INJURED,
  DELETE_NEW_NOTE_ACCIDENT,
  ADD_NEW_ACCIDENT_DATA,
  CLEAR_ACCIDENT_DATA,
  GET_TRANSPORT_ACCIDENT_INFO,
  GET_BOAT_INFO_BY_REGNUM,
  DELETE_ACCIDENT_FILE,
  SET_ERROR_TRANSPORT_ACCIDENT,
  SET_ERROR_TERMINATION_CASE,
  SET_BOAT_INFO_BY_REGNUM_STATUS,
} from "../types";

import {
  MAIN_URL,
  PORT_FOR_REPORT,
  API_FIND_BOAT_INFO_BY_REGNUM,
  API_GET_TRANSPORT_ACCIDENT_LIST_SEARCH,
  API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_ADD,
  API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_EDIT,
  API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_FORM,
  API_DELETE_TRANSPORT_ACCIDENT_VICTIMS_INFO,
  API_DELETE_TRANSPORT_ACCIDENT_CAUSERS_INFO,
  API_ADD_TRANSPORT_ACCIDENT_FILE,
  API_GET_TRANSPORT_ACCIDENT_FILELIST,
  API_DELETE_TRANSPORT_ACCIDENT_FILE,
  API_TERMINATION_CASE,
} from "../../constants/constants";

import { fetchWithToken } from "../../interceptors/fetchInterceptor";

export function addNewCulprit(newCulprit) {
  return {
    type: ADD_NEW_CULPRIT,
    data: newCulprit,
  };
}
export function addNewInjured(newInjured) {
  return {
    type: ADD_NEW_INJURED,
    data: newInjured,
  };
}
export function deleteNewNoteAccident(innerData) {
  if (innerData.mode === "add") {
    return {
      type: DELETE_NEW_NOTE_ACCIDENT,
      data: innerData,
    };
  }
  if (innerData.mode === "edit") {
    return async (dispatch) => {
      let request;
      switch (innerData.type) {
        case "victimsList":
          request = await fetchWithToken(
            MAIN_URL + PORT_FOR_REPORT + API_DELETE_TRANSPORT_ACCIDENT_VICTIMS_INFO + innerData.id,
          );
          break;
        case "causersList":
          request = await fetchWithToken(
            MAIN_URL + PORT_FOR_REPORT + API_DELETE_TRANSPORT_ACCIDENT_CAUSERS_INFO + innerData.id,
          );
          break;
        default:
          break;
      }
      if (request.status === 200) {
        dispatch({
          type: DELETE_NEW_NOTE_ACCIDENT,
          data: innerData,
        });
      }
    };
  }
}
export function addNewAccidentData(data) {
  return {
    type: ADD_NEW_ACCIDENT_DATA,
    data: data,
  };
}

export function findBoatInfoByRegNum(regNum) {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_REPORT + API_FIND_BOAT_INFO_BY_REGNUM + regNum);
    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: SET_BOAT_INFO_BY_REGNUM_STATUS,
        data: "success",
      });
      dispatch({
        type: GET_BOAT_INFO_BY_REGNUM,
        data: data,
      });
    } else {
      const data = {};
      data.boatVidId = null;
      data.boatTypeId = null;
      data.boatName = "";
      data.ownerLename = "";
      data.ownerLeUnp = "";
      data.ownerSurname = "";
      data.ownerName = "";
      data.ownerMidname = "";
      data.ownerBirthDate = null;
      dispatch({
        type: SET_BOAT_INFO_BY_REGNUM_STATUS,
        data: response.status === 404 ? "not-found" : "reject",
      });
      dispatch({
        type: GET_BOAT_INFO_BY_REGNUM,
        data: data,
      });
    }
  };
}

export function clearAccidentData(personType = undefined) {
  return {
    type: CLEAR_ACCIDENT_DATA,
    data: personType ? { personType: personType } : {},
  };
}
export function deleteAccidentFile(id, filename) {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL + PORT_FOR_REPORT + API_DELETE_TRANSPORT_ACCIDENT_FILE + id + "/" + filename,
      {
        method: "POST",
      },
    );
    if (request.status === 200) {
      const deleteId = await request.text();
      dispatch({
        type: DELETE_ACCIDENT_FILE,
        data: deleteId,
      });
    }
  };
}

export function getAccidentInfoById(id) {
  return async (dispatch) => {
    const requestMain = await fetchWithToken(
      MAIN_URL + PORT_FOR_REPORT + API_GET_TRANSPORT_ACCIDENT_LIST_SEARCH + "/" + id,
    );
    if (requestMain.status === 200) {
      const responseMain = await requestMain.json();
      const requestFiles = await fetchWithToken(
        MAIN_URL + PORT_FOR_REPORT + API_GET_TRANSPORT_ACCIDENT_FILELIST + responseMain.id,
      );
      const responseFiles = await requestFiles.json();
      const data = {
        data: responseMain,
        fileList: responseFiles,
      };
      dispatch({
        type: GET_TRANSPORT_ACCIDENT_INFO,
        data: data,
      });
    }
  };
}

export function saveTransportAccident(mode, newAccidentData, causersList, victimsList, id, fileList) {
  const API = (() => {
    switch (mode) {
      case "add":
        return API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_ADD;
      case "edit":
        return API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_EDIT;
      case "form":
        return API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_FORM;

      default:
        break;
    }
  })();
  newAccidentData.locked = mode === "form";
  if (id) {
    if (newAccidentData.ownerMidname === null) {
      delete newAccidentData.ownerMidname;
    }
    if (newAccidentData.ownerName === null) {
      delete newAccidentData.ownerName;
    }
    if (newAccidentData.ownerSurname === null) {
      delete newAccidentData.ownerSurname;
    }
    if (newAccidentData.ownerWorkplace === null) {
      delete newAccidentData.ownerWorkplace;
    }
    if (newAccidentData.ownerBirthDate === null) {
      delete newAccidentData.ownerBirthDate;
    }
    if (newAccidentData.ownerLeUnp === null) {
      delete newAccidentData.ownerLeUnp;
    }
    if (newAccidentData.ownerLename === null) {
      delete newAccidentData.ownerLename;
    }
    newAccidentData.id = id;
    // return async (dispatch) => {
    //
    //   const request = await fetchWithToken(MAIN_URL + PORT_FOR_REPORT + API, {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     method: "POST",
    //     body: JSON.stringify(newAccidentData),
    //   });
    //   if (request.status === 200) {
    //     const response = await request.json();
    //
    //
    //
    //
    //     if (!!fileList && Object.values(fileList).length > 0) {
    //       for (let item of fileList) {
    //         const formData = new FormData();
    //         formData.append("file", item);
    //         const request = await fetchWithToken(
    //           MAIN_URL +
    //             PORT_FOR_REPORT +
    //             API_ADD_TRANSPORT_ACCIDENT_FILE +
    //             `?refidId=${response.id}`,
    //           {
    //             method: "POST",
    //             body: formData,
    //           },
    //         );
    //       }
    //     }
    //   }
    // };
  }

  return async (dispatch) => {
    dispatch({
      type: SET_ERROR_TRANSPORT_ACCIDENT,
      data: "",
    });
    let formData = new FormData();

    for (let item of causersList) {
      if (item.hasOwnProperty("innerId")) {
        delete item.innerId;
      }
    }

    for (let item of victimsList) {
      item.drunk = item.drunk === "true" || item.drunk === true;
      if (item.hasOwnProperty("innerId")) {
        delete item.innerId;
      }
    }

    newAccidentData.boatIncidentCausers = causersList;
    newAccidentData.boatIncidentVictims = victimsList;

    formData.append("data", JSON.stringify(newAccidentData));
    if (fileList?.length > 0) {
      fileList.forEach((item) => formData.append("file", item));
    }

    const response = await fetchWithToken(MAIN_URL + PORT_FOR_REPORT + API, {
      method: "POST",
      mode: "cors",
      body: formData,
    });

    if (response.ok) {
      dispatch({
        type: SET_ERROR_TRANSPORT_ACCIDENT,
        data: "success",
      });
    } else {
      dispatch({
        type: SET_ERROR_TRANSPORT_ACCIDENT,
        data: "reject",
      });
    }
  };
}

// Возвращаем ошибку

// if (Object.values(fileList).length > 0) {
//   for (let item of fileList) {
//     const formData = new FormData();
//     formData.append("file", item);
//     const request = await fetchWithToken(
//       MAIN_URL +
//         PORT_FOR_REPORT +
//         API_ADD_TRANSPORT_ACCIDENT_FILE +
//         `?refidId=${response.id}`,
//       {
//         method: "POST",
//         body: formData,
//       },
//     );
//   }
// }
// }

export const terminationCase = (id, data) => {
  return async (dispatch) => {
    dispatch({
      type: SET_ERROR_TERMINATION_CASE,
      data: "",
    });
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_REPORT + API_TERMINATION_CASE + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      dispatch({
        type: SET_ERROR_TERMINATION_CASE,
        data: "success",
      });
    } else {
      dispatch({
        type: SET_ERROR_TERMINATION_CASE,
        data: "reject",
      });
    }
  };
};
